import React from 'react';

const OurIntiatives = () => {
  return (
    <div>
      <h1>Offers Page</h1>
    </div>
  );
};

export default OurIntiatives;